import PropTypes from 'prop-types'
import React from 'react'
import CustomLink from '../CustomLink'
import { CustomButtom } from './styles'

export default function BotaoCTA(props) {
  const { actionPlace, botao, botaoEmbaixo, external } = props
  const onBg = props.onBg ? props.onBg : 'light'
  const estilo = botao.estilo ? botao.estilo : 'primary'
  const cor = botao.cor && estilo === 'primary' ? botao.cor : ''
  const label = botao.corLabel && estilo === 'primary' ? botao.corLabel : ''
  const rota = botao.rota ? botao.rota.endereco : '/'
  const tagLabel = botao.rota ? botao.rota.tagLabel : ''
  const labelMobile = props.somentePrimeiraPalavra
    ? botao.label.split(' ')[0]
    : botao.label

  return (
    <CustomLink
      to={botao.disabled ? '#' : rota}
      tagLabel={tagLabel}
      target={external ? '_blank' : '_self'}
      parentComponent={actionPlace}
      botaoEmbaixo={botaoEmbaixo}
      disabled={botao.disabled}
    >
      <CustomButtom
        blur={botao.blur}
        color={estilo}
        label={labelMobile}
        onBg={onBg}
        onClick={!botao.disabled && botao.onClick}
        style={{
          backgroundColor: cor,
          color: label,
          border: botao.corBorder ? `solid 1px ${botao.corBorder.cor || botao.corBorder}` : undefined,
        }}
        disabled={botao.disabled}
      />
    </CustomLink>
  )
}

BotaoCTA.propTypes = {
  botao: PropTypes.object.isRequired,
  onBg: PropTypes.string
}
